import { render, staticRenderFns } from "./EstoqueInstrumento.vue?vue&type=template&id=3f0d3944&"
import script from "./EstoqueInstrumento.vue?vue&type=script&lang=js&"
export * from "./EstoqueInstrumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports